/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon32Regular = forwardRef('ArrowDim1VIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "m17 4.418.06.057 5.733 5.732a1 1 0 0 0 1.414-1.414l-5.732-5.732a3.5 3.5 0 0 0-4.95 0L7.793 8.793a1 1 0 0 0 1.414 1.414l5.732-5.732c.02-.02.04-.039.061-.057v23.165a1.553 1.553 0 0 1-.06-.058l-5.733-5.732a1 1 0 1 0-1.414 1.414l5.732 5.733a3.5 3.5 0 0 0 4.95 0l5.732-5.733a1 1 0 0 0-1.414-1.414l-5.732 5.732c-.02.02-.04.04-.061.058V4.418Z" })));
});
